import React from "react";

export default function EmptyPosition({
  width = 121,
  height = 116,
  ...rest
}: {
  width?: number;
  height?: number;
  [x: string]: any;
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 121 116"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <rect x="5" y="50" width="2" height="44" fill="#292C3B" />
      <rect y="66" width="12" height="11" fill="#292C3B" />
      <rect x="65" y="41" width="2" height="24" fill="#292C3B" />
      <rect x="65" width="2" height="23" fill="#292C3B" />
      <rect x="60.5" y="30.5" width="11" height="10" stroke="#292C3B" />
      <rect x="25" y="60" width="2" height="34" fill="#323847" />
      <rect x="20" y="63" width="12" height="14" fill="#323847" />
      <rect x="45" y="60" width="2" height="24" fill="#323847" />
      <rect x="40.5" y="30.5" width="11" height="29" stroke="#323847" />
      <rect x="105" y="10" width="2" height="74" fill="#323847" />
      <rect x="100" y="21" width="12" height="50" fill="#323847" />
      <rect x="85" y="69" width="2" height="26" fill="#292C3B" />
      <rect x="80.5" y="41.5" width="11" height="29" stroke="#292C3B" />
      <circle
        cx="62.4717"
        cy="57.4717"
        r="26.6038"
        fill="url(#paint0_linear_2347_4258)"
        fillOpacity="0.1"
      />
      <path
        d="M120.364 109.597L120.364 109.597C120.451 109.684 120.5 109.802 120.5 109.925C120.5 110.048 120.451 110.166 120.364 110.252C120.364 110.253 120.364 110.253 120.364 110.253L115.241 115.364L115.241 115.364C115.154 115.451 115.036 115.5 114.913 115.5C114.79 115.5 114.672 115.451 114.585 115.364L114.585 115.364L84.0705 84.8611L83.7596 84.5503L83.4116 84.8189C77.3777 89.4746 70.0122 91.9997 62.2498 91.9997C52.9589 91.9997 44.2386 88.3864 37.6821 81.8183L37.6818 81.8179C31.1249 75.2611 27.5 66.5287 27.5 57.2498C27.5 47.9589 31.1133 39.2386 37.6814 32.6821L37.6818 32.6818C44.2386 26.1249 52.971 22.5 62.2498 22.5C71.5291 22.5 80.2612 26.1134 86.8176 32.6814C93.375 39.2505 96.9997 47.9596 96.9997 57.2498C96.9997 65.0124 94.4745 72.3893 89.8075 78.4228L89.5382 78.771L89.8494 79.0823L120.364 109.597ZM81.2149 76.2157L81.2153 76.2153C86.2794 71.1513 89.0697 64.4088 89.0697 57.2498C89.0697 50.0905 86.2792 43.3602 81.2157 38.2848C76.1511 33.2082 69.4083 30.43 62.2498 30.43C55.0905 30.43 48.3602 33.2205 43.2848 38.284L43.2844 38.2844C38.2203 43.3484 35.43 50.0909 35.43 57.2498C35.43 64.4092 38.2205 71.1395 43.284 76.2149L43.2848 76.2157C48.3602 81.2792 55.0905 84.0697 62.2498 84.0697C69.4092 84.0697 76.1395 81.2792 81.2149 76.2157Z"
        fill="#242836"
        stroke="#323847"
      />
      <defs>
        <linearGradient
          id="paint0_linear_2347_4258"
          x1="35.8679"
          y1="57.4717"
          x2="89.0755"
          y2="57.4717"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#A6CCDC" />
          <stop offset="1" stopColor="#C0E9FA" />
        </linearGradient>
      </defs>
    </svg>
  );
}
